<template>
  <div class="official_twitter_recommend">
    <div class="justify">
      <div class="justify link-twitter col-sm-9 col-md-11 col-lg-10">
        <a href="https://twitter.com/gachatuku" rel="twitter" target="_blank"><i class="fa-twitter"></i>ガチャつく公式Twitterをフォロー</a>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

export default {
  methods: {
    makeLink() {
      router.push('/make');
    }
  }
}
</script>

<script>
import router from '@/router'

export default {
  methods: {
    makeLink() {
      router.push('/make');
    }
  }
}
</script>

<style scoped>
@import '../css/common.css';

.official_twitter_recommend {
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 10px;
}
.link-twitter {
  padding: 0px;
}
.link-twitter > a {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  color: #07a0e2;
}
</style>